import React, { Component } from "react";
import "./ClubUpdates.css";
import ReactPaginate from "react-paginate";
import $ from "jquery";
import OutsideClickHandler from "react-outside-click-handler";
import { Row, Col } from "react-bootstrap";
import { FiThumbsUp } from "react-icons/fi";
import { NotificationManager } from "react-notifications";
import { Container } from "@mui/material";
class ClubUpdates extends Component {
  // Constructor initializes the state and binds necessary methods.
constructor(props) {
  super(props);
  this.state = {
    tenders: [], // Stores list of tenders
    tendersFilter: [], // Stores list of filtered tenders
    offset: 0, // The offset for pagination
    tensdersPageCount: 1, // Total number of pages for pagination
    perPage: 3, // Number of items to display per page
    currentPage: 0, // Current page number
    checked: false, // Tracks checkbox state
    postCategoryIdVlaue: "", // The post category ID
    InitialAccessToken: localStorage.getItem("GlobalAccess"), // Access token from local storage
    subCategoriesList: [], // List of subcategories
    copyOfTenders: [], // A copy of tenders for filtering
    contentOwners: [], // List of content owners
  };
  this.handlePageClick = this.handlePageClick.bind(this);
  this.isComponentMounted = false; // Flag to check component mount status
}

// ComponentDidMount is called after the component is mounted to the DOM.
componentDidMount() {
  this.postCategoryIdValue(); // Fetches the category ID
}

// Fetches category ID and triggers necessary actions after successful fetch
postCategoryIdValue() {
  this.isComponentMounted = true;
  fetch(
    `${window.appConfig.getContentCategories}${window.appConfig.Relam}${window.appConfig.Relam}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.state.InitialAccessToken,
      },
    }
  )
    .then((res) => res.json())
    .then((result) => {
      if (!this.isComponentMounted) return; // Prevents setting state after component unmount

      const postid = result.categoryList.filter(
        (data) => data.categoryname === "CLUB-UPDATES"
      );

      if (postid.length === 0) {
        console.warn("No matching category found");
        return;
      }

      const categoryId = postid[0].categoryid;

      // Perform actions based on fetched category ID
      this.viewAllBranding(categoryId);
      this.setState({
        postCategoryIdValue: categoryId, 
      });
      this.adminsDropdownClick(categoryId);
      this.getCategorySubcategories(categoryId);
      this.ownerDropdownClick(categoryId);
    })
    .catch((err) => console.log("Fetch error:", err));
}

// Cleanup method when component is about to unmount
componentWillUnmount() {
  this.isComponentMounted = false; // Set the flag to false when the component unmounts
}

// Fetches and sets the list of tenders for a given category ID
viewAllBranding(postid) {
  fetch(
    `${window.appConfig.getContentList}${window.appConfig.Relam}category/${postid}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.state.InitialAccessToken,
      },
    }
  )
    .then((res) => res.json())
    .then((result) => {
      this.setState({
        tenders: result.contentList,
        copyOfTenders: result.contentList,
        tensdersPageCount: Math.ceil(result.contentList.length / this.state.perPage),
      });
    });
}

// Fetches content creator data based on category ID for dropdown filtering
adminsDropdownClick(catID) {
  fetch(
    `${window.appConfig.getContentCreator}${window.appConfig.Relam}contentcreators/${catID}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.state.InitialAccessToken,
      },
    })
    .then((res) => res.json())
    .then((result) => {
      // Ensure unique content creators by filtering out duplicates
      const unique = [
        ...new Map(result.contentcreatorsList.map((data) => [data.contentcreatorid, data])).values(),
      ];
      this.setState({
        tendersFilter: unique,
      });
    })
    .catch((err) => console.log("err", err));
}

// Toggles dropdown visibility for content creators
organizationsDropdownClick() {
  $("#dropdownClubUpdates").toggle();
}

// Handles click on content creator in dropdown to filter tenders
organizationsOnClick(Creator) {
  fetch(
    `${window.appConfig.getContentonContentCreator}${window.appConfig.Relam}contentcreator/${Creator}/${this.state.postCategoryIdVlaue}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.state.InitialAccessToken,
      },
    })
    .then((res) => res.json())
    .then((result) => {
      this.setState({
        tenders: result.contentList,
        tensdersPageCount: Math.ceil(result.contentList.length / this.state.perPage),
      });
    })
    .catch((err) => console.log("err", err));
  $("#dropdownClubUpdates").hide(); // Hide dropdown after selection
}

// Fetches and sets subcategories based on category ID
getCategorySubcategories(catID) {
  if(!catID) return; // If no category ID, return early
  fetch(`${window.appConfig.getContentSubcategories}${window.appConfig.Relam}${window.appConfig.Relam}${window.appConfig.Relam}${catID}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.state.InitialAccessToken,
      },
    })
    .then((res) => res.json())    
    .then((result) => {
      this.setState({
        subCategoriesList: result.contentsubcategories,
      });
    })
    .catch((err) => console.log("err", err));
}

// Toggles dropdown visibility for subcategories
subCategoriesDropdownClick() {
  $("#subCategoriesOfClub").toggle();
}

// Handles click on subcategory in dropdown to filter tenders
subCategoriesOnClick(subCategory) {
  const subCategoriesOfAdsFilter = this.state.copyOfTenders.filter(
    (data, index) => {
      return data.contentsubcategory
        .toLowerCase()
        .includes(subCategory.toLowerCase());
    }
  );
  this.setState({
    tenders: subCategoriesOfAdsFilter,
    tensdersPageCount: Math.ceil(subCategoriesOfAdsFilter.length / this.state.perPage),
  });
  $("#subCategoriesOfClub").hide(); // Hide dropdown after selection
}

// Likes the content and triggers an update
likeCount(contentid) {
  fetch(
    `${window.appConfig.contentLikeCount}${window.appConfig.Relam}${contentid}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "text/plain",
        Authorization: "Bearer " + this.state.InitialAccessToken,
      },
    })
    .then((res) => res.text())
    .then((result) => {
      this.postCategoryIdValue(); // Refresh data after liking
      return NotificationManager.success(result); // Show success notification
    })
    .catch((err) => console.log("err", err));
}

// Fetches and sets content owners based on category ID
ownerDropdownClick(catID) {
  fetch(
    `${window.appConfig.getAllContentOwnersBasedOnCategory}${catID}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.state.InitialAccessToken,
      },
    })
    .then((res) => res.json())
    .then((result) => {
      // Ensure unique content owners by filtering out duplicates
      const unique = [
        ...new Map(result.contentownerList.map((data) => [data.contentowner, data])).values(),
      ];
      this.setState({
        contentOwners: unique,
      });
    })
    .catch((err) => console.log("err", err));
}

// Toggles dropdown visibility for content owners
contentOwnerDropdownClick() {
  $("#ContentOwnerOfClub").toggle();
}

// Handles click on content owner to filter tenders
getContentOwnerContent(Owner) {
  fetch(
    `${window.appConfig.getContentList}${window.appConfig.Relam}contentowner/${Owner}/${this.state.postCategoryIdVlaue}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.state.InitialAccessToken,
      },
    })
    .then((res) => res.json())
    .then((result) => {
      this.setState({
        tenders: result.contentList,
        tensdersPageCount: Math.ceil(result.contentList.length / this.state.perPage),
      });
    })
    .catch((err) => console.log("err", err));
  $("#dropdownOrganizations").hide(); // Hide dropdown after selection
}

// Handles pagination clicks and updates the current page and offset
handlePageClick = (e) => {
  const selectedPage = e.selected;
  const offset = selectedPage * this.state.perPage;

  this.setState(
    {
      currentPage: selectedPage,
      offset: offset,
    },
    () => {}
  );
};


render() {
  const { tenders, subCategoriesList, contentOwners } = this.state;  // Destructuring state for necessary data
  const brandingList = tenders.slice(  // Slicing the tenders data based on the current offset and perPage settings
    this.state.offset,
    this.state.offset + this.state.perPage
  );

  return (
    <Container>
      {/* Main container for the tenders section */}
      <div
        id="tendersContainer"
        className="mb-lg-5 mb-4 mt-4 gbr-engage-container container-fluid"
      >
        <div>
          {/* Title section */}
          <h3 className="container-title">GBR Updates</h3>
          <div className="mb-4">
            {/* Dropdown for 'All Club Updates' button */}
            <div className="dropdown">
              <div className="navbarRight">
                <button
                  className="btn btn-success homepageBtn"
                  type="button"
                  onClick={() =>
                    this.viewAllBranding(this.state.postCategoryIdVlaue)  // View all branding updates
                  }
                >
                  All Club Updates
                </button>
              </div>
            </div>

            {/* Dropdown for selecting a Publisher */}
            <div className="dropdown">
              <div className="dropdown homepage-nav-item">
                <div className="navbarRight">
                  <button
                    className="btn btn-success homepageBtn"
                    type="button"
                    aria-haspopup="true"
                    aria-expanded="false"
                    onClick={() => this.organizationsDropdownClick()}  // Opens the Publisher dropdown
                  >
                    Publisher
                  </button>
                </div>
                <div
                  className="dropdown-menu"
                  id="dropdownClubUpdates"
                  aria-labelledby="dropdownClubUpdates"
                >
                  {/* Mapping through tendersFilter to display Publisher options */}
                  {this.state.tendersFilter &&
                    this.state.tendersFilter.map((filter, i) => (
                      <li key={i}>
                        <a
                          className="dropdown-item"
                          role="button"
                          onClick={() =>
                            this.organizationsOnClick(filter.contentcreatorid)  // On Publisher selection
                          }
                        >
                          {filter.contentcreatorid}
                        </a>
                      </li>
                    ))}
                </div>
              </div>
            </div>

            {/* Dropdown for selecting a Sub Category */}
            <div className="dropdown">
              <div className="dropdown homepage-nav-item">
                <div className="navbarRight">
                  <button
                    className="btn btn-success homepageBtn"
                    type="button"
                    aria-haspopup="true"
                    aria-expanded="false"
                    onClick={() => this.subCategoriesDropdownClick()}  // Opens the Sub Categories dropdown
                  >
                    Sub Categories
                  </button>
                </div>
                <div
                  className="dropdown-menu"
                  id="subCategoriesOfClub"
                  aria-labelledby="subCategoriesOfClub"
                >
                  {/* Mapping through subCategoriesList to display Sub Category options */}
                  {subCategoriesList &&
                    subCategoriesList.map((filter, i) => (
                      <li key={i}>
                        <a
                          className="dropdown-item"
                          role="button"
                          onClick={() =>
                            this.subCategoriesOnClick(
                              filter.contentsubcategoryname  // On Sub Category selection
                            )
                          }
                        >
                          {filter.contentsubcategoryname}
                        </a>
                      </li>
                    ))}
                </div>
              </div>
            </div>

            {/* Dropdown for selecting a Club Owner */}
            <div className="dropdown">
              <div className="dropdown homepage-nav-item">
                <div className="navbarRight">
                  <button
                    className="btn btn-success homepageBtn"
                    type="button"
                    aria-haspopup="true"
                    aria-expanded="false"
                    onClick={() => this.contentOwnerDropdownClick()}  // Opens the Club Owner dropdown
                  >
                    Club Owner
                  </button>
                </div>
                <div
                  className="dropdown-menu"
                  id="ContentOwnerOfClub"
                  aria-labelledby="ContentOwnerOfClub"
                >
                  {/* Mapping through contentOwners to display Club Owner options */}
                  {contentOwners &&
                    contentOwners.map((filter, i) => (
                      <li key={i}>
                        <a
                          className="dropdown-item"
                          role="button"
                          onClick={() =>
                            this.getContentOwnerContent(
                              filter.contentowner  // On Club Owner selection
                            )
                          }
                        >
                          {filter.contentowner}
                        </a>
                      </li>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Displaying the list of branding updates */}
        <div className="adminTendersDiv">
          {brandingList.length !== 0 ? (  // If there are branding updates to display
            <Row className="justify-content-center">
              {/* Iterating through brandingList to display each branding item */}
              {brandingList.map((tend, index) => (
                <Col md={6} lg={4} sm={12} xs={12} className="mb-4" key={index}>
                  <div className="community-cards w-100">
                    <div className="bordered-div"></div>

                    <div className="pb-2">
                      <div className="scrollable-container scrollable-container-mod">
                        <div className="community-card-body">
                          <div className="d-flex justify-content-between align-items-center mb-2 mt-2">
                            <span className="d-block ">{tend.contentsubcategory}</span>
                            <p className="products-like mb-0 d-flex align-items-end">
                              <span
                                className="d-inline-block"
                                onClick={() => {
                                  this.likeCount(tend.contentid);  // Increment like count on click
                                }}
                              >
                                <FiThumbsUp size={30} />
                              </span>
                              <small>{tend.likecount}</small>
                            </p>
                          </div>

                          <h2 className="mb-0">{tend.contentname}</h2>
                          <h5 className="mb-2">
                            Posted by <span>{tend.contentcreatorid}</span>, {tend.timestamp}
                          </h5>
                          <a className="text-decoration-none" href={tend.texturl} target="_blank">
                            <h6 className="mb-3">{tend.contentdescription}</h6>
                          </a>

                          <img
                            className="img-thumbnail"
                            src={tend.locationurl}
                            width="100%"
                            height="250"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}

              {/* Pagination for the branding updates */}
              <div className="paginationComponent">
                <ReactPaginate
                  previousLabel={"<<"}
                  nextLabel={">>"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={this.state.tensdersPageCount}  // Page count for pagination
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={this.handlePageClick}  // Handle page change
                  containerClassName={"pagination"}
                  subContainerClassName={"pages pagination"}
                  activeClassName={"active"}
                />
              </div>
            </Row>
          ) : (
            <div className="card">
              <p className="card-body container-heading2">
                <b>Club Updates Not Found</b>
              </p>
            </div>
          )}
        </div>

        {/* Handling click outside of dropdowns to close them */}
        <OutsideClickHandler
          onOutsideClick={() => {
            $("#dropdownClubUpdates").hide();
            $("#subCategoriesOfClub").hide();
            $("#ContentOwnerOfClub").hide();
          }}
        >
          <></>
        </OutsideClickHandler>
      </div>
    </Container>
  );
}

}

export default ClubUpdates;
